import { Button, Col, Drawer, Input, Row } from "antd";
import { Table } from "components";
import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { delayedDispatch, setBreadcrumb, setTitle, updateCrumb } from "store/actions";
import { API, Endpoints } from "utils/api";
import Strings from "utils/strings";
import { toast } from "utils/utils";

class BlogTag extends Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            tags: [],
            hasUnsavedFields: false,
            loading: false,
            tempTag: {},
        };
    }

    componentDidMount() {
        const { dispatch } = this.props;

        dispatch(setTitle(Strings.sidebar.blogPosts));

        delayedDispatch(
            setBreadcrumb(() => {
                return {
                    locations: [
                        {
                            text: Strings.sidebar.settings,
                            route: "/settings",
                            icon: "preferences",
                        },
                        {
                            text: Strings.sidebar.blogTags,
                            icon: "tag",
                        },
                    ],
                };
            })
        );

        this.getBlogTag();
    }

    componentDidUpdate() {
        const { dispatch } = this.props;
        dispatch(updateCrumb());
    }

    getBlogTag = async () => {
        const response = await API.get({
            url: Endpoints.uriBlogPostTags(),
        });

        if (response.ok) {
            this.setState({ tags: response.data.results || [] });
        }
    };

    patchBlogTag = async (original: any) => {
        const { tags } = this.state;

        const response = await API.patch({
            url: Endpoints.uriBlogPostTags(original._id),
            data: {
                active: !original.active,
            },
        });

        if (response.ok) {
            const updatedBlogTags = tags.map((tag: any) => {
                if (tag._id === original._id) {
                    return { ...tag, active: !tag.active };
                }
                return tag;
            });

            this.setState({ tags: updatedBlogTags });
        }
    };

    isValid = () => {
        const { tempTag } = this.state;

        if (!tempTag?.name?.trim()) {
            return false;
        }

        return true;
    };

    saveBlogTag = async () => {
        const { tempTag, tags } = this.state;

        if (!this.isValid()) {
            return toast.warn(Strings.errors.invalidFields);
        }

        this.setState({ loading: true });

        const response = tempTag._id ? API.put : API.post;

        try {
            const apiResponse = await response({
                url: Endpoints.uriBlogPostTags(tempTag._id ?? ""),
                data: {
                    name: tempTag.name,
                    active: tempTag.active,
                },
            });

            if (apiResponse.ok) {
                if (!tempTag._id) {
                    tags.push(apiResponse.data.results.tag);
                } else {
                    const updatedBlogTagIndex = tags.findIndex((tag: any) => tag._id === tempTag._id);

                    if (updatedBlogTagIndex !== -1) {
                        tags[updatedBlogTagIndex] = apiResponse.data.results.tag;
                    }
                }

                this.setState({
                    tags,
                    hasUnsavedFields: false,
                    showAdd: false,
                    tempTag: {},
                });

                toast.success(Strings.blogPosts.tagSaved);
            } else {
                toast.error(Strings.blogPosts.somethingWentWrong);
            }
        } catch (error) {
            console.log("error", error);
        }

        this.setState({ loading: false });
    };

    onAdd() {
        this.setState({ showAdd: true, tempTag: {} });
    }

    onClose() {
        this.setState({ showAdd: false, tempTag: {} });
    }

    renderSidebar() {
        const { showAdd, tempTag, loading, hasUnsavedFields } = this.state;

        return (
            <Drawer
                visible={showAdd}
                onClose={() => this.onClose()}
                width={500}
                title={tempTag?._id ? Strings.blogPosts.editTag : Strings.blogPosts.addTag}
                footer={
                    <div className="DrawerFooter">
                        <Button
                            type="primary"
                            onClick={() => {
                                this.saveBlogTag();
                            }}
                            loading={loading}
                            disabled={!hasUnsavedFields}
                        >
                            {Strings.generic.save}
                        </Button>
                        <Button
                            type="default"
                            onClick={() => {
                                this.onClose();
                            }}
                        >
                            {Strings.generic.cancel}
                        </Button>
                    </div>
                }
                placement="right"
            >
                <Row gutter={[20, 20]}>
                    <Col xs={24}>
                        <label className="SingleLabel __required">{Strings.fields.name}</label>
                        <Input
                            placeholder={Strings.fields.name}
                            value={tempTag?.name || ""}
                            onChange={(e) => {
                                const value = e.target.value;

                                this.setState((state: any) => ({
                                    tempTag: { ...state.tempTag, name: value },
                                    hasUnsavedFields: true,
                                }));
                            }}
                        />
                    </Col>
                </Row>
            </Drawer>
        );
    }

    render() {
        const { tags } = this.state;

        return (
            <React.Fragment>
                <Helmet>
                    <title>{Strings.sidebar.blogTags}</title>
                    <meta name="description" content="Description of Blog Tags" />
                </Helmet>
                <Table
                    title={{
                        icon: "tag",
                        title: Strings.sidebar.blogTags,
                    }}
                    data={tags}
                    columns={[
                        {
                            Header: Strings.fields.name,
                            id: "name",
                            accessor: (row: any) => row.name,
                        },
                    ]}
                    paginated={false}
					isSinglePage
					filterable={false}
                    add={{
                        label: String(
                            Strings.formatString(Strings.generic.addNewF, Strings.blogPosts.tag.toLowerCase())
                        ),
                        onClick: () => this.onAdd(),
                    }}
                    actions={{
                        edit: (original, value) => ({
                            onClick: () => {
                                this.setState({ showAdd: true, tempTag: JSON.parse(JSON.stringify(original)) });
                            },
                        }),
                        toggle: (original, value) => ({
                            value: original.active,
                            onChange: () => this.patchBlogTag(original),
                        }),
                    }}
                />
                {this.renderSidebar()}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: any) => ({});

export default connect(mapStateToProps)(BlogTag);
